import React, { useState, useEffect, useCallback } from 'react';
import GoogleMapReact from 'google-map-react';
import { useHistory } from 'react-router-dom';
import useApi from '../../api/useApi';
import '../../scrollbar.css';
import ShowZone from '../../components/ShowZone';
import AddZone from '../../components/AddZone';
import MapComponent from '../../components/MapComponent';
import Notification from '../../components/Notification';

function Zone() {
  const user = sessionStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(sessionStorage.user).organization.id;
  const [openCreate, setOpenCreate] = useState(false);
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState();
  const [message, setMessage] = useState();
  const [{ isLoading, isError, data }] = useApi();
  const [zones, zoneData] = useApi();
  const [zone, setzone] = useState([]);
  const [openZone, setOpenZone] = useState(false);
  const [addZone, setAddZone] = useState(false);
  const [id, setId] = useState(null);
  const [showFloorMap, setShowFloorMap] = useState(false);
  const [zoomedLocationFloorMap, setZoomedLocationMap] = useState();

  const history = useHistory();
  const [center, setCenter] = useState({
    lat: 32.874525,
    lng: -117.2160221,
  });
  const [coordinates, setCoordinates] = useState([center]);
  const [cor, setCor] = useState([]);

  useEffect(() => {
    user && zoneData(`/organization/${orgId}/zones`, 'GET');
  }, []);

  useEffect(() => {
    if (!zones.isLoading && !zones.isError && zones.data) {
      const zonesFiltered = zones.data && zones.data.length > 0 && zones.data.filter((x) => x.location !== null);
      const _zones =
        zonesFiltered &&
        zonesFiltered.length > 0 &&
        zonesFiltered.sort((a, b) => (a.location.toLowerCase() > b.location.toLowerCase() ? 1 : -1));
      setzone(_zones);
      for (let i = 0; i < _zones.length; i++) {
        if (_zones[i].gateways.length > 0 && _zones[i].gateways[0].latitude && _zones[i].gateways[0].longitude) {
          cor.push({
            lat: parseFloat(_zones[i].gateways[0].latitude),
            lng: parseFloat(_zones[i].gateways[0].longitude),
          });
        }
      }
      setCoordinates(cor);
    }
  }, [zones.isLoading, zones.isError, zones.data]);

  const getMapOptions = (maps) => {
    return {
      streetViewControl: false,
      scaleControl: true,
      fullscreenControl: true,
      gestureHandling: 'greedy',
      disableDoubleClickZoom: true,
      minZoom: 1,

      mapTypeControl: true,
      mapTypeControlOptions: {
        style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
        position: maps.ControlPosition.BOTTOM_CENTER,
        mapTypeIds: [maps.MapTypeId.ROADMAP, maps.MapTypeId.SATELLITE, maps.MapTypeId.HYBRID],
      },

      zoomControl: true,
      clickableIcons: true,
    };
  };

  const handlegoogleApi = (map, maps, places) => {
    const markers = [];
    const bounds = new maps.LatLngBounds();
    places.forEach((place, idx) => {
      markers.push(
        new maps.Marker({
          position: { lat: place.lat, lng: place.lng },
          icon: 'assets/img/marker.svg',
          map,
          title: `(${zone[idx]?.location}, ${place.lat}, ${place.lng})`,
        })
      );
      if (place.lat && place.lng) bounds.extend(place);
    });
    map.fitBounds(bounds);
    bounds.getCenter();
  };

  const toggleOpenZone = (prev) => {
    setOpenZone((prev) => !prev);
  };

  const toggleAddZone = (prev) => {
    setAddZone(false);
  };

  const refreshList = () => {
    toggleAddZone();
    user && zoneData(`/organization/${orgId}/zones`, 'GET');
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      <div
        className="h-full fixed hideScroll m-8 w-full left-44 view_width "
        style={{ filter: openCreate && 'blur(2px)', overflow: 'auto', left: '14%', width: '81%' }}
      >
        {/* <div className="w-full h-screen map_zone" style={{ height: '94vh' }}> */}
        <div className="flex mr-2 absolute top-0 left-0 z-50">
          <button
            className={`${
              location.pathname.includes('zones') ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
            } px-4 h-7 text-xs focus:outline-none`}
            onClick={() => {
              localStorage.setItem('warehouseORzone', 'zones');
              history.push('/zones');
            }}
          >
            Zones
          </button>
          <button
            className={`${
              location.pathname.includes('warehouse') ? 'bg-btnBg text-white' : 'text-black bg-gray-400'
            } px-4 h-7 text-xs focus:outline-none`}
            onClick={() => {
              localStorage.setItem('warehouseORzone', 'warehouses');
              history.push('/warehouses');
            }}
          >
            Warehouses
          </button>
        </div>
        {!openZone &&
          cor.length > 0 &&
          (showFloorMap ? (
            <div className="relative">
              <button
                className="absolute w-28 lg:w-max border px-3 py-1  text-xs right-10 top-2 font-bold focus:outline-none flex justify-center items-center h-8 bg-btnBg text-white rounded-md"
                onClick={() => setShowFloorMap(false)}
              >
                Show Map
              </button>
              <img src={zoomedLocationFloorMap} alt="" className="h-5/6 w-full " />
            </div>
          ) : (
            <>
              <MapComponent
                selectedPage="zone"
                coordinates={coordinates}
                center={center}
                selectedData={zone}
                setShowFloorMap={setShowFloorMap}
                setZoomedLocationMap={setZoomedLocationMap}
              />
            </>
          ))}
        {/* </div> */}
        <div className="absolute z-50 w-full top-12 flex">
          {!isLoading && (
            <div className="exampleZones border bg-tableBg absolute h-screen shadow-md max-w-screen-xl mx-auto sm:w-full w-1/5 px-3 py-3">
              {zone.length > 0 ? (
                <div className="flex items-center justify-between">
                  <h1 className="text-base text-titleColor font-bold bg-white ml-3 mb-2">Zones</h1>
                  {/* <div 
                    className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs  font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile1"
                    onClick={() => {setAddZone(true)}}
                  >Add</div> */}
                </div>
              ) : (
                <div className="flex items-center justify-between">
                  <h1 className="text-base text-titleColor text-center bg-white ml-3 mb-2">No Zones Available</h1>
                  {/* <div className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-md text-xs  font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white button_mobile1"   onClick={() => {setAddZone(true)}}>Add</div> */}
                </div>
              )}
              <div
                className="pb-1 hideScroll"
                style={{ borderColor: '#e6e6e6', height: '78vh', overflow: 'auto', borderBottom: 'none' }}
              >
                {zone.length > 0 &&
                  // !openZone &&
                  zone.map((item, idx) => (
                    <div
                      className="my-2 px-3 py-1 bg-white flex rounded-md
                  shadow-sm relative border hover:border-indigo-200 focus-within:border-indigo-200"
                    >
                      <div className=" py-1 text-xs w-full">
                        <a
                          href="#"
                          className="font-bold text-textBlue1 capitalize text-sm"
                          onClick={(e) => {
                            setId(e.target.id);
                            setOpenZone(true);
                          }}
                          id={idx}
                        >
                          {` ${item.location !== null ? item.location : 'undefined'}`}
                        </a>
                        <div className="flex my-0 mt-1.5 text-titleColor font-medium text-xs">{item?.geoLocation}</div>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          )}
          {isLoading && <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />}

          {openZone && (
            <div className="border absolute bg-white" style={{ width: '78%', left: '21%', height: '83vh' }}>
              <ShowZone gatewayData={zone[id]} handleClose={toggleOpenZone} />
            </div>
          )}

          {addZone && (
            <AddZone handleClose={toggleAddZone} notification={createNotification} refreshList={() => refreshList()} />
          )}
        </div>
      </div>
    </>
  );
}

export default Zone;
